// src/components/atoms/auth/auth-submit-button.tsx
import * as React from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

type AuthSubmitButtonProps = Omit<React.ComponentProps<typeof Button>, "children"> & {
  loading?: boolean;
  showArrow?: boolean;
  children: string;
};

export function AuthSubmitButton({
  loading = false,
  showArrow = true,
  children,
  className,
  disabled,
  ...props
}: AuthSubmitButtonProps) {
  return (
    <Button
      type="submit"
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={cn(
        "min-h-11 w-full justify-center gap-2 rounded-xl bg-brand px-8 text-base font-semibold text-white shadow-sm transition-colors hover:bg-brand/90 focus-visible:ring-brand/40",
        className,
      )}
      {...props}
    >
      {loading ? (
        <Loader2 aria-hidden className="size-4 animate-spin motion-reduce:animate-none" />
      ) : null}
      <span>{children}</span>
      {showArrow && !loading ? <ArrowRight aria-hidden className="size-4" /> : null}
    </Button>
  );
}
